import { render, staticRenderFns } from "./AssignView.vue?vue&type=template&id=3ac5a379&scoped=true&"
import script from "./AssignView.vue?vue&type=script&lang=js&"
export * from "./AssignView.vue?vue&type=script&lang=js&"
import style0 from "../style/side-box.scss?vue&type=style&index=0&id=3ac5a379&scoped=true&lang=scss&"
import style1 from "../style/staff.scss?vue&type=style&index=1&id=3ac5a379&scoped=true&lang=scss&"
import style2 from "../style/assign-view.scss?vue&type=style&index=2&id=3ac5a379&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac5a379",
  null
  
)

export default component.exports